import React from 'react';
import styled from 'styled-components';
import github from '../img/github.svg';
import linkedin from '../img/linkedin.svg';
import email from '../img/email.svg';

function Footer() {
  const FOOTER = styled.div`
        width: 100%;
        background-color: #181818;
        display: flex;
        flex-direction: row;
        height: 100px;
        padding: 4rem 0;
        align-items: center;
        justify-content: center;
    `;

  const LogoContainer = styled.div`
        flex-basis: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        justify-items: center;
        background-color: transparent;
    `;

  const P = styled.p`
        width: max-content;
        background-color: transparent;
    `;

  const A = styled.a`
        width: max-content;
        text-decoration: none;
        align-items: center;
        text-align: center;
        background-color: transparent;
        color: #fafafa;
    `;

  const Img = styled.img`
        width: 50px;
        background-color: transparent;
        margin: auto;
    `;

  return (
    <FOOTER>
      <LogoContainer>
        <A
          href="https://www.linkedin.com/in/murilo-cardoso-dos-santos-4616ab1a0"
          target="_blank"
          rel="noreferrer"
        >
          <Img src={linkedin} alt="linkedin" />
          <P>Linkedin</P>
        </A>
      </LogoContainer>

      <LogoContainer>
        <A
          href="https://www.github.com/5gMurilo"
          target="_blank"
          rel="noreferrer"
        >
          <Img src={github} alt="Github" />

          <P className="py-4 text-sm md:text-base">Github</P>
        </A>
      </LogoContainer>

      <LogoContainer>
        <A href="mailto:murilocssantos02@gmail.com">
          <Img src={email} alt="email" />
          <P className="py-4 text-sm sm:text-sm py-2"> E-mail </P>
        </A>
      </LogoContainer>
    </FOOTER>
  );
}

export default Footer;
